/* Suppress runtime errors thrown by third-party browser extensions
   (1Password, LastPass, Bitwarden, Dashlane, Honey, etc.) which inject
   content scripts into every page and frequently crash on our form fields.

   These errors are NOT bugs in our application — they originate from
   extension code we don't control — but React's dev error overlay shows
   them globally, making it impossible to use the admin UI when an
   extension misbehaves.

   We filter by error message signatures and the source script URL.
   Anything coming from the extension scheme (chrome-extension://,
   moz-extension://, safari-web-extension://) or matching a known noisy
   pattern is silently swallowed.
*/

const EXT_PATTERNS = [
  /autofillFieldData/i,
  /autoCompleteType/i,
  /chrome-extension:\/\//i,
  /moz-extension:\/\//i,
  /safari-web-extension:\/\//i,
  /lastpass/i,
  /1password/i,
  /bitwarden/i,
  /dashlane/i,
  /^Script error\.$/i, // cross-origin opaque
];

function looksLikeExtensionError(message, source) {
  const blob = `${message || ""} ${source || ""}`;
  return EXT_PATTERNS.some((re) => re.test(blob));
}

export function installExtensionErrorFilter() {
  if (typeof window === "undefined") return;
  if (window.__SAVEBOX_EXT_FILTER__) return;
  window.__SAVEBOX_EXT_FILTER__ = true;

  window.addEventListener(
    "error",
    (event) => {
      const src = event.filename || (event.error && event.error.stack) || "";
      const msg = event.message || (event.error && event.error.message) || "";
      if (looksLikeExtensionError(msg, src)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        // eslint-disable-next-line no-console
        console.debug("[savebox] swallowed extension error:", msg);
        return false;
      }
    },
    true,
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const reason = event.reason || {};
      const msg = (typeof reason === "string" ? reason : reason.message) || "";
      const src = (reason.stack || "") + "";
      if (looksLikeExtensionError(msg, src)) {
        event.preventDefault();
        // eslint-disable-next-line no-console
        console.debug("[savebox] swallowed extension promise rejection:", msg);
      }
    },
    true,
  );
}
